
import BoxInfoEditComponent from "../../../components/box_infos/Edit.vue";

export default {
  components: {
    BoxInfoEditComponent
  }
}
